if (
  typeof String !== undefined
  && String.prototype
  && !String.prototype.removeSpecialCharacters
) {
  Object.defineProperty(String.prototype, 'removeSpecialCharacters', {
    value(characters) {
      if (characters) return this.replace(characters, '');
      return this.replace(/[^\w\s]/gi, '');
    }
  });
}